import React from "react";

const PlayIcon = () => (
  <svg
    className="correction360px"
    viewBox="-0.5 0 8 8"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Dribbble-Light-Preview"
        transform="translate(-427.000000, -3765.000000)"
        fill="#000000"
      >
        <g id="icons" transform="translate(56.000000, 160.000000)">
          <polygon
            id="play-[#1001]"
            points="371 3605 371 3613 378 3609"
          ></polygon>
        </g>
      </g>
    </g>
  </svg>
);

const PauseIcon = () => (
  <svg
    className="correction360px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 1H2V15H7V1Z" fill="#000000" />
    <path d="M14 1H9V15H14V1Z" fill="#000000" />
  </svg>
);

// Shuffle Icon (Off state)
const ShuffleOffIcon = () => (
  <svg
    className="correction360px"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="invisible_box" data-name="invisible box">
        <rect width="48" height="48" fill="none" />
      </g>
      <g id="Q3_icons" data-name="Q3 icons">
        <g>
          <path d="M42,22H6a2,2,0,0,0,0,4H42a2,2,0,0,0,0-4Z" />
          <path d="M6,18H42a2,2,0,0,0,0-4H6a2,2,0,0,0,0,4Z" />
          <path d="M42,30H6a2,2,0,0,0,0,4H42a2,2,0,0,0,0-4Z" />
          <polygon points="24 4 18 10 30 10 24 4" />
          <polygon points="24 44 30 38 18 38 24 44" />
        </g>
      </g>
    </g>
  </svg>
);

// Shuffle Icon (On state)
const ShuffleOnIcon = () => (
  <svg
    className="correction360px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 1H12V3H10.5858L7 6.58579L3.41421 3H0V5H2.58579L5.58579 8L2.58579 11H0V13H3.41421L11.4142 5H12V7H13L16 4L13 1Z"
      fill="#000000"
    />
    <path
      d="M12 9H13L16 12L13 15H12V13H10.5858L8.41421 10.8284L9.82843 9.41421L11.4142 11H12V9Z"
      fill="#000000"
    />
  </svg>
);

// Loop Icon (Off state)
const LoopOffIcon = () => (
  <svg
    className="correction360px"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 1V15H9V13H14V3H9V1L16 1Z" fill="#000000" />
    <path d="M6 4V7L8.74229e-08 7L0 9H6V12H7L11 8L7 4H6Z" fill="#000000" />
  </svg>
);

// Loop Icon (On state)
const LoopOnIcon = () => (
  <svg
    className="correction360px"
    fill="#000000"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M20 7v7c0 1.103-.896 2-2 2H2c-1.104 0-2-.897-2-2V7a2 2 0 0 1 2-2h7V3l4 3.5L9 10V8H3v5h14V8h-3V5h4a2 2 0 0 1 2 2z" />
  </svg>
);

// Rewind Button Icon
const RewindIcon = () => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    className="correction360px2"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 14H8L8 9L13 14H15L15 2H13L8 7L8 2H6L0 8L6 14Z" fill="#000000" />
  </svg>
  // <svg
  //   className="correction360px2"
  //   viewBox="0 0 24 24"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <g>
  //     <path fill="none" d="M0 0h24v24H0z" />
  //     <path d="M12 10.667l9.223-6.149a.5.5 0 0 1 .777.416v14.132a.5.5 0 0 1-.777.416L12 13.333v5.733a.5.5 0 0 1-.777.416L.624 12.416a.5.5 0 0 1 0-.832l10.599-7.066a.5.5 0 0 1 .777.416v5.733z" />
  //   </g>
  // </svg>
);

// Fast Forward Button Icon
const FastForwardIcon = () => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    className="correction360px2"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 14H1L1 2H3L8 7L8 2H10L16 8L10 14H8L8 9L3 14Z" fill="#000000" />
  </svg>

  // <svg
  //   version="1.1"
  //   className="correction360px2"
  //   id="_x32_"
  //   xmlns="http://www.w3.org/2000/svg"
  //   viewBox="0 0 512 512"
  // >
  //   <g>
  //     <path
  //       class="st0"
  //       d="M508.882,250.515L235.601,87.36c-1.952-1.142-4.438-1.215-6.462-0.049c-1.97,1.116-3.204,3.289-3.204,5.572
  // 	v123.61L9.646,87.36c-1.95-1.142-4.436-1.215-6.461-0.049C1.252,88.428,0,90.601,0,92.883v163.143v163.056
  // 	c0,2.357,1.252,4.492,3.185,5.586c2.025,1.19,4.511,1.116,6.461-0.025l216.289-129.132v123.572c0,2.357,1.234,4.492,3.204,5.586
  // 	c2.025,1.19,4.511,1.116,6.462-0.025l273.281-163.155c1.964-1.142,3.118-3.204,3.118-5.462
  // 	C512,253.755,510.846,251.62,508.882,250.515z"
  //     />
  //   </g>
  // </svg>
);

export {
  PlayIcon,
  PauseIcon,
  RewindIcon,
  FastForwardIcon,
  ShuffleOffIcon,
  ShuffleOnIcon,
  LoopOffIcon,
  LoopOnIcon,
};
